import React, { useState } from 'react'
import Accordion from '../../Accordion/Accordion'
import AccordionChild from '../../AccordionChild/AccordionChild'
import IconWithLink from '@/components/IconWithLink'
import faqPageSchema from '@/utils/schema/faqPageSchema'
import { normalizeFaqAnswer } from '@/utils/normalizeFaqAnswer'
import { FAQ } from '@/types/models/Faq.model'
import LinkButton from '@/components/atoms/LinkButton/LinkButton'
import IconChevronDownXs from '@/components/icons/IconChevronDownXs/IconChevronDownXs'

type Props = {
  customFAQs: FAQ[]
  questionsAsHeading?: boolean
  compact?: boolean
}

const CustomFAQs: React.FC<Props> = ({
  customFAQs,
  questionsAsHeading,
  compact
}) => {
  const [showAll, setShowAll] = useState(false)
  const faqSchema = faqPageSchema(customFAQs)

  return (
    <>
      <script
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        type="application/ld+json"
      />
      <Accordion>
        {customFAQs.map((faq, index) => (
          <AccordionChild
            heading={faq.question}
            as={questionsAsHeading ? 'h4' : 'span'}
            compact={compact}
            className={`${index >= 5 && !showAll ? 'hidden' : ''}`}
            key={index}
          >
            <div
              className="list-disc text-gray-800"
              dangerouslySetInnerHTML={{
                __html: normalizeFaqAnswer(faq.answer)
              }}
            />
            {faq.link && (
              <a
                href={faq.link}
                className="mt-4 flex h-[60px] items-center justify-start gap-3 overflow-hidden rounded-2xl bg-gray-50 py-2 pl-3 pr-4  hover:bg-gray-100 focus:bg-gray-200"
              >
                <div className="flex size-9 items-center justify-center gap-2 rounded-xl border border-gray-300 bg-white p-2">
                  <IconWithLink className="text-gray-1100 lg:size-6" />
                </div>
                <div className="h-[44px] items-center gap-0.5">
                  <div className="inline-flex h-11 shrink grow basis-0 flex-col items-center justify-center gap-1">
                    <div className="font-figtree line-clamp-1 self-stretch break-all text-sm font-medium leading-4 text-gray-1100 hover:underline lg:text-xs lg:leading-4">
                      {faq.label}
                    </div>
                    <div className="font-figtree line-clamp-1 text-ellipsis break-all text-sm font-normal leading-4 text-gray-900 underline lg:text-xs lg:leading-4">
                      {faq.link}
                    </div>
                  </div>
                </div>
              </a>
            )}
          </AccordionChild>
        ))}
        {!showAll && customFAQs.length > 5 && (
          <LinkButton
            label="Show More FAQs"
            onClick={() => setShowAll(true)}
            className="!text-sm !tracking-[.15px]"
            iconElement={
              <IconChevronDownXs
                strokeWidth="0.2"
                className="ml-0.5 text-gray-1100"
              />
            }
          />
        )}
      </Accordion>
    </>
  )
}

export default CustomFAQs
